import { createStore, combineReducers, applyMiddleware } from "redux";
import { persistReducer, persistStore } from "redux-persist";
import { userReducer } from "./Slices/user.slice";
import { authReducer } from "./Slices/auth.slice";
import { playerReducer } from "./Slices/player.slice";
import { loadingReducer } from "./Slices/loading.slice";
import { thunk } from "redux-thunk";

const createNoopStorage = () => {
  return {
    getItem(_key) {
      return Promise.resolve(localStorage.getItem(_key));
    },
    setItem(_key, value) {
      return Promise.resolve(localStorage.setItem(_key, value));
    },
    removeItem(_key) {
      return Promise.resolve(localStorage.removeItem(_key));
    },
  };
};

// Persist Config
const persistConfig = {
  key: "mnbwtvStore",
  storage: createNoopStorage(),
  // Loading is transient. Rehydrating it can leave navigation disabled forever.
  blacklist: ["Auth", "Loading"],
  version: 1,
  migrate: function (state) {
    if (!state || !state.Loading) return Promise.resolve(state);

    var migratedState = Object.assign({}, state);
    delete migratedState.Loading;
    return Promise.resolve(migratedState);
  },
};

// Separate persist config for Auth - blacklist activeSection
const authPersistConfig = {
  key: "Auth",
  storage: createNoopStorage(),
  blacklist: ["activeSection"],
};

// Combine Reducers
const rootReducer = combineReducers({
  User: userReducer,
  Auth: persistReducer(authPersistConfig, authReducer),
  Player: playerReducer,
  Loading: loadingReducer,
});

// Persisted Reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create Store with Middleware
export const store = createStore(
  persistedReducer,
  applyMiddleware(thunk) // Adding Thunk middleware for async actions
);

// Persistor
export const persistor = persistStore(store);
